<template>
    <modal @close="removePromotionCancelClick" class="edit-modal" id="remove-promotion" hide-footer>
        <div class="td-edit-container">
            <div class="pagination">
                <div class="form-name">
                    <h3>Remove Promotion</h3>
                    <p>
                        If you remove this promotion, any funds available on your promotion will be automatically moved to your account credit.
                    </p>
                </div>
            </div>
            <div class="edit-pages td-form">
                <div class="mb-2">
                    <h4 class="td-h4">Please confirm</h4>
                    <p class="ma-0">
                        Are you sure you want to remove this promotion?  If you would rather just remove any funds, click on the "Remove Funds" link instead.
                    </p>
                </div>
                <div class="actions mt-3">
                    <div>
                        <button class="td-btn primary-outlined" @click="removePromotionCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn danger" @click="removePromotionSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Remove</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './RemovePromotion';
    export default script;
</script>
<style lang="less">
    @import './RemovePromotion.less';
</style>